import MyWorkLocalSettings from "../../my-work-local-settings";


export default function myWorkToggleIsCompactMenu() {

    const localSettings = new MyWorkLocalSettings()

    localSettings.toggleIsSubmenuCompact()

    gd.bus.triggerEvent('toggle-submenu', localSettings.isSubmenuCompact)
}
